import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import JobsPage from './pages/JobsPage.jsx';
// Hidden 2026-05-21 — see App.jsx routes comment. Files kept; uncomment
// these imports + the matching routes below to re-enable.
// import ApplicationsPage from './pages/ApplicationsPage.jsx';
// import InboxPage from './pages/InboxPage.jsx';
// Hidden 2026-06-12 — Earnings archived from the UI (page + hook kept).
// Uncomment this import + the matching route below and the TABS entry in
// BottomNav.jsx to re-enable.
// import EarningsPage from './pages/EarningsPage.jsx';
import ReferralsPage from './pages/ReferralsPage.jsx';
import ProfilePage from './pages/ProfilePage.jsx';
import SettingsPage from './pages/SettingsPage.jsx';
import OnboardingFlow from './pages/OnboardingFlow.jsx';
import LoginPage from './pages/LoginPage.jsx';
import AuthCallbackPage from './pages/AuthCallbackPage.jsx';
import TermsPage from './pages/TermsPage.jsx';
import PrivacyPage from './pages/PrivacyPage.jsx';
import { useAuth } from './contexts/AuthContext.jsx';
import { useApp } from './contexts/AppContext.jsx';

function RootRedirect() {
  const { user, loading: authLoading } = useAuth();
  const { interviewee, loading: appLoading } = useApp();

  if (authLoading || appLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-200 border-t-teal-600" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (interviewee?.career_onboarding_step === 'complete') {
    return <Navigate to="/dashboard/jobs" replace />;
  }
  return <Navigate to="/onboarding" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/onboarding" element={<OnboardingFlow />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="jobs" replace />} />
        <Route path="jobs" element={<JobsPage />} />
        {/* Hidden 2026-05-21 after the pivot to link-only matchmaking.
            Inbox was never built. Page components still exist — uncomment
            these routes AND the matching TABS entries in BottomNav.jsx
            to re-enable. Bookmarks to /dashboard/applications and
            /dashboard/inbox now fall through to the * catchall →
            redirect to /dashboard/jobs. */}
        {/* <Route path="applications" element={<ApplicationsPage />} /> */}
        {/* <Route path="inbox" element={<InboxPage />} /> */}
        {/* Hidden 2026-06-12 — Earnings archived. Bookmarks to
            /dashboard/earnings now fall through to the * catchall →
            redirect to /dashboard/jobs. */}
        {/* <Route path="earnings" element={<EarningsPage />} /> */}
        <Route path="referrals" element={<ReferralsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard/jobs" replace />} />
    </Routes>
  );
}
